// Config
import { getProtocol } from './getProtocol';

export const isHttps = () => getProtocol() === 'https:';
